module.exports = __webpack_public_path__ + "static/media/sl.0ab96fdf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sl.svg
// module id = 939
// module chunks = 0